import React, { useEffect, useState } from 'react'
import '../styles/program.scss'
//import DatePickerContainer from '../datepicker/DatePickerContainer'
//import CONSTANTS from '../movielist-constants'
//import xml2js from '../../lib/xml-to-js';
//import DayPicker from 'react-day-picker';
//import moment from 'moment'
//import downarrow from './images/down-arrow-backup-2-svgrepo-com (1).svg'
import check from "../images/check-mark.svg";
//import checkIcon from "./images/check-mark.svg";


export default function Films({ films, moviearr, setMoviearr, setRegarr, setCinemaarr , setSelectedDate }) {
 
   

    const [isOpen, setIsOpen] = useState(false);
  
   

    function handleRegionArrrow() {
        setIsOpen((current) => !current);
    }

   // console.log(films, 'films at films')
   // console.log(moviearr, 'movie arr')

    function handleFilmClick(item) {
      //  console.log(item, 'item')
        if (moviearr.includes(item.name)) {
            setMoviearr(moviearr.filter(r => { return r !== item.name }))
           
        }
        else setMoviearr([...moviearr, item.name])
    }
 
    return (
        
        <div className=" dropdownContainer">
            
                {/*<div style={{ display: 'flex', justifyContent: 'space-between' }}>*/}
                 
                {/*    <button onClick={cancelAllFilters} className='cancelAllFilters'*/}
                {/*       >Nulstil alle filtre</button>*/}
                {/*</div>*/}
                       
            <div className="chooseRegion" style={{
                borderBottomLeftRadius: isOpen ? '0px' : '8px',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                borderBottomRightRadius: isOpen ? '0px' : '8px',
            }}>
                            <div
                                style={{
                        position: "relative", boxSizing: "border-box",top:'-1px'
                                
                        
                                }}
                            >
                        <p style={{
                            paddingTop: '10px',
                           fontSize: '18px', paddingLeft: '16px', overflow: 'hidden', textOverflow: 'elipsis', whiteSpace: 'nowrap', width: '200px',letterSpacing: '0.54px'
                        }}>{moviearr && moviearr.length === 1 ? moviearr[0] : moviearr?.length > 0 ? 'Valgte film' : 'Alle film'}</p>
                        {moviearr?.length > 0 && moviearr.length && < span className="one"> {moviearr.length } </span> }
                             
                        <button className='chooseBtn'
                                    onClick={handleRegionArrrow}
                                    
                                >
                                    <p >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                    <path d="M1.5 1L10 10L18.5 1" stroke="white" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                    </p>
                                </button>
                            </div>
                    {isOpen && (
                        <div className='scroll'
                            style={{
                               // borderLeft: "1px solid #757575",
                                //borderRight: "1px solid #757575",
                              //  borderBottom: "1px solid #757575",
                                // color: '#999',
                               top:'0px',
                                backgroundColor: "#2B3040",
                                maxHeight: "270px",
                                overflowX: 'auto',
                                position: 'relative',
                                zIndex: 100,
                                width: '100%'
                            }}
                        >
                            {films && films.map((item, index) => (
                                item.name &&
                                <div key={index} style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    height: "44px",
                                        padding: " 10px", borderRadius: '6px',
                                       // borderRight: '1px solid #757575',
                                        marginRight: '2px', width: '95%',
                                        backgroundColor: moviearr.length && moviearr.includes(item.name) ? '#3E455C' : ''

                                }} onClick={() => handleFilmClick(item)}>
                                        <p style={{ margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '200px', fontSize: '18px', fontWeight: 500, letterSpacing: '0.54px' }}>{item.name}</p>
                                 
                                        {moviearr.length && moviearr.includes(item.name) ?
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                                <path d="M7 11L11 16L17.5 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                                            </svg>
                                            :
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                            </svg>}
                                   
                                </div>
                            ))
                            }
                           
                       </div>
                            )}
                        </div>
                   
                    
                </div>
               

           
        )
}